import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper"

export const useInventoryHistory = ({ editData }) => {

    const [historyData, setHistoryData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [media, setMedia] = useState({ visible: false, data: {} });
    const rowClassRules = { "inventory-history-highlight": (params) => { return (!params?.data?.returned_date && !_.findWhere(params?.data?.child, { ch_asset_unique_id: editData?.asset_unique_id })?.ch_returned_date) } }
    const [colDef] = useState([
        {
            field: "srno",
            headerName: "S.No",
            width: 50,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "asset_unique_id",
            headerName: "Parent Assigned",
            flex: 1,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "assigned_date",
            headerName: "Assigned Date",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => dateConvert(params?.value, "day-month-year")
        },
        {
            field: "returned_date",
            headerName: "Returned Date",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? dateConvert(params?.value, "day-month-year") : ""}</div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "Assigned To",
            flex: 1,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "assets_assignee_name",
            headerName: "Assigned By",
            flex: 1,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "assigned_remark",
            headerName: "Assign Remark",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const value = !params?.value ? _.findWhere(params?.data?.child, { ch_asset_unique_id: editData?.asset_unique_id })?.ch_assigned_remark : params?.value;
                return (
                    <div title={value}>{value}</div>
                )
            }
        },
        {
            field: "returned_remark",
            headerName: "Return Remark",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const value = !params?.value ? _.findWhere(params?.data?.child, { ch_asset_unique_id: editData?.asset_unique_id })?.ch_returned_remark : params?.value
                return (
                    <div title={value}>{value}</div>
                )
            }
        },
        {
            field: "media",
            headerName: "Media",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="text-primary c-pointer" onClick={() => setMedia({ visible: true, data: params?.data })}>View</div>
                )
            }
        },
    ])

    useEffect(() => {
        !_.isEmpty(editData) && getAssetHitory();
    }, [editData])

    const getAssetHitory = async () => {
        try {
            setHistoryData([]);
            setLoader(true);
            const res = await services.getInvokeRemote("POST", Urls("GETASSETSTRANSHISTORY"), { asset_id: editData?.asset_id || 0 });
            if (res) {
                const data = res?.body?.data?.asset_trans_history;
                const mediaData = res?.body?.data?.asset_media_trans_history;
                const sortedData = data?.sort((a, b) => {
                    const aReturned = a?.returned_date;
                    const bReturned = b?.returned_date;
                    if (aReturned === null) return -1;
                    if (bReturned === null) return 1;
                    return new Date(bReturned) - new Date(aReturned);
                });

                let historyArray = [];
                sortedData?.forEach((item, index) => {
                    let mediaArr = { assign: [], return: [] }
                    const media = _.filter(mediaData, (obj) => obj?.asset_tran_id === item?.asset_tran_id);
                    media?.forEach((med) => {
                        const type = med?.asset_trans_media_type?.trim()?.toLowerCase();
                        if (type === "a") {
                            mediaArr.assign = mediaArr.assign.concat(med?.pr_asset_unique_file_id?.split(","));
                        } else if (type === "r") {
                            mediaArr.return = mediaArr.return.concat(med?.pr_asset_unique_file_id?.split(","));
                        }
                    })
                    mediaArr = {
                        assign: _.uniq(mediaArr?.assign)?.map((img) => { return { file: img, base64: img } }),
                        return: _.uniq(mediaArr?.return)?.map((img) => { return { file: img, base64: img } }),
                    }
                    if (_.isEmpty(_.findWhere(historyArray, { asset_tran_id: item?.asset_tran_id }))) {
                        historyArray.push({...item, media: mediaArr, srno: index + 1});
                    }
                })
                setHistoryData(historyArray);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error getting asset history: ", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        colDef, historyData, loader, media, setMedia, rowClassRules
    }), [colDef, historyData, loader, media, setMedia, rowClassRules])
}